import axios from "axios";

export const BASE_URL = "https://satkartarcrmcall.satkartar.me/";
//export const BASE_URL = "http://localhost/satkartarcrmcall/";

const apiClient = axios.create({ baseURL: BASE_URL });

const normalizeError = (error) => ({
  data: {
    status: 0,
    msg: error?.response?.data?.msg || error?.message || "Unable to connect to hospital server.",
  },
  status: error?.response?.status || 0,
});

export const hospitalPost = async (url, data) => {
  try {
    return await apiClient({
      method: "POST",
      url,
      data,
      headers: { "Content-Type": "multipart/form-data" },
    });
  } catch (error) {
    return normalizeError(error);
  }
};
